export const MANUALLY_ADDED = "MANUALLY_ADDED";
export const AUTO_MATCHED = "AUTO_MATCHED";
export const AUTO_MATCH_CONFIRM = "AUTO_MATCH_CONFIRM";
